import { useState } from 'react'
import homepagePillarCard from 'src/data/homepage-pillars-card-data.json'

function PillarsCard(){
    return(
        <div className="grid grid-cols-1 lg:grid-cols-3 justify-center lg:divide-x md:mx-[80px] lg:mx-[160px] xl:mx-[240px]">
            {homepagePillarCard.map(card => {
                
                return(
                    <div className={`flex flex-col justify-top items-center gap-[8px] px-[32px]`}>
                        <img className='w-[125px] md:w-[150px] lg:w-[200px] h-max' src={card.src}></img>
                        <div className='flex flex-col'> 
                            <p className='font-lora font-semibold text-[20px]'>{card.title}</p>
                            <p className='text-grey leading-[1.25]'>{card.description}</p>
                        </div>
                    </div>
                )
            })}
        </div>
    )
}

export default PillarsCard